import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Inline, Text } from '@ui-lib';

import * as style from './Pill.css';
import type { FieldVisibility } from './types';

const toFriendlyName = (name: string) => {
  switch (name) {
    case 'middleName':
      return 'Middle name';
    case 'honorificPrefix':
      return 'Prefix';
    case 'honorificSuffix':
      return 'Suffix';
    case 'maidenName':
      return 'Maiden name';
    case 'preferredName':
      return 'Preferred name';
    case 'pronouns':
      return 'Pronoun';
  }
};

export const NameFieldSuggestions = ({
  fieldVisibility,
  setFieldVisibility,
  disabled,
}: {
  fieldVisibility: FieldVisibility;
  setFieldVisibility: (newFieldVisibility: FieldVisibility) => void;
  disabled?: boolean;
}): JSX.Element => {
  const handleClick = (key: string) => {
    setFieldVisibility({
      ...fieldVisibility,
      [key]: true,
    });
  };

  const pills = Object.entries(fieldVisibility)
    .filter((entry) => entry[1] === false)
    .map(([key]) => (
      <Box
        component="button"
        type="button" // prevent button click from submitting the form
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="small"
        paddingX="medium"
        paddingY="xsmall"
        cursor="pointer"
        className={style.Pill}
        onClick={() => handleClick(key)}
        key={key}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faPlus} />
        <Text weight="demibold" size="small">
          {toFriendlyName(key)}
        </Text>
      </Box>
    ));

  return <Inline gap="xsmall">{pills}</Inline>;
};
